import React from 'react';
import * as Util from '../../../util';
import { Switch } from 'antd';
import DrawerAnchor from '../../UI/DrawerAnchor';
import { withIsMobile } from 'treeline-react-core-components/WindowSizeProvider';
import TitleFilterAttribute from './TitleFilterAttribute';
import MobileDrawerHeader from '../../UI/MobileDrawerHeader';

export class TitleFilter extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			visible: false,
			filteredTitleCount: 0,
			activeFilterSections: [],
			activeFilters: [],
			filterListKey: null,
		};
	}

	render() {
		const isMobile = this.props.isMobile();
		const { parentStyle } = this.props;
		return (
			<DrawerAnchor
				closable={true}
				width={isMobile ? '100%' : '700px'}
				placement={isMobile ? 'bottom' : 'left'}
				height={isMobile ? '90%' : '100%'}
				parentStyle={parentStyle}
				renderDrawerContent={this.renderDrawerContent}>
				{this.props.children}
			</DrawerAnchor>
		);
	}

	renderDrawerContent = drawer => {
		return drawer.isVisible && this.renderTitleFilter();
	};

	renderTitleFilter = () => {
		const { titles, listKey } = this.props;
		const { filterListKey } = this.state;
		if (listKey !== filterListKey) {
			this.setState({
				filteredTitleCount: 0,
				filteredTitles: [],
				filterListKey: this.props.listKey,
				activeFilterSections: [],
				activeFilters: [],
			});
		}
		const { filteredTitleCount } = this.state;
		return (
			<React.Fragment>
				<MobileDrawerHeader header="Filters" />
				<div
					style={{
						margin: '20px',
						padding: '20px',
						backgroundColor: '#ffffff',
					}}>
					<div style={{ marginBottom: '10px' }}>
						<div
							className="column"
							style={{ fontSize: '18px', fontWeight: 'bold' }}>
							{filteredTitleCount === titles.length ||
							filteredTitleCount === 0 ? (
								<span>No Filters Active</span>
							) : (
								<span>
									{filteredTitleCount} of {titles.length}{' '}
									Titles
								</span>
							)}
						</div>
						<div className="clear" />
					</div>
					<div>
						{this.renderFilterSection(
							TitleFilterAttribute.Supplier,
						)}
					</div>
					<div>
						{this.renderFilterSection(TitleFilterAttribute.Format)}
					</div>
					<div>
						{this.renderFilterSection(
							TitleFilterAttribute.Category,
						)}
					</div>
					<div>
						{this.renderFilterSection(TitleFilterAttribute.Series)}
					</div>
					<div>
						{this.renderFilterSection(
							TitleFilterAttribute.PubDateRange,
						)}
					</div>
					<div>
						{this.renderFilterSection(
							TitleFilterAttribute.PublishingStatus,
						)}
					</div>
					<div>
						{this.renderFilterSection(
							TitleFilterAttribute.ReviewCopyAvailability,
						)}
					</div>
					<div>
						{this.renderFilterSection(
							TitleFilterAttribute.MarkupNoteIndicator,
						)}
					</div>
				</div>
			</React.Fragment>
		);
	};

	onChange(e, attribute, item) {
		if (e === true) {
			this.addFilter(attribute, item);
		} else {
			this.removeFilter(attribute, item);
		}
	}

	addFilter = (attribute, item) => {
		const activeFilters = this.state.activeFilters;
		activeFilters.push({
			attribute: attribute,
			item: item,
		});
		this.setState(
			{
				activeFilters: activeFilters,
			},
			this.filterResults,
		);
	};

	removeFilter = (attribute, item) => {
		const activeFilters = this.state.activeFilters;
		this.setState(
			{
				activeFilters: activeFilters.filter(
					af =>
						af.attribute != attribute ||
						(af.attribute == attribute && af.item != item),
				),
			},
			this.filterResults,
		);
	};

	toggleFilterSection(e, titleFilterAttribute) {
		const { activeFilterSections } = this.state;
		var newActiveFilterSections = activeFilterSections;
		if (e === true) {
			newActiveFilterSections.push(titleFilterAttribute.attribute);
		} else {
			newActiveFilterSections = newActiveFilterSections.filter(
				afs => afs != titleFilterAttribute.attribute,
			);
		}
		this.setState(
			{
				activeFilterSections: newActiveFilterSections,
			},
			this.filterResults,
		);
	}

	renderFilterSection = titleFilterAttribute => {
		const { activeFilterSections } = this.state;
		const isActive =
			activeFilterSections.filter(
				afs => afs === titleFilterAttribute.attribute,
			).length > 0;
		const { titles } = this.props;
		const filteredList =
			titles && Util.groupBy(titles, titleFilterAttribute.attribute);
		return (
			<React.Fragment>
				{Object.keys(filteredList).length > 1 && (
					<div style={{ marginBottom: '10px' }}>
						<div>
							<div className="column">
								<Switch
									checkedChildren="On"
									unCheckedChildren="Off"
									defaultChecked={isActive}
									onChange={e =>
										this.toggleFilterSection(
											e,
											titleFilterAttribute,
										)
									}
								/>
							</div>
							<div
								className="column-spaced bold"
								style={{ marginTop: '2px' }}>
								{Object.keys(filteredList).length}{' '}
								{titleFilterAttribute.label} Filters
							</div>
							<div className="clear" />
						</div>
						{isActive && (
							<div
								style={{
									marginLeft: '28px',
									marginTop: '10px',
								}}>
								{this.renderFilterOptions(titleFilterAttribute)}
							</div>
						)}
					</div>
				)}
			</React.Fragment>
		);
	};

	renderFilterOptions = titleFilterAttribute => {
		const { titles } = this.props;
		const { filteredTitles } = this.state;
		const originalFilteredList =
			titles && Util.groupBy(titles, titleFilterAttribute.attribute);
		const filteredList =
			filteredTitles &&
			Util.groupBy(filteredTitles, titleFilterAttribute.attribute);
		var sorted = [];
		for (var key in originalFilteredList) {
			sorted[sorted.length] = key;
		}
		sorted.sort();
		return sorted.map((item, idx) => (
			<div>
				<div className="column">
					<Switch
						size="small"
						checkedChildren="Include"
						unCheckedChildren="Exclude"
						defaultChecked={this.getInitialState(
							titleFilterAttribute.attribute,
							item,
						)}
						onChange={e =>
							this.onChange(
								e,
								titleFilterAttribute.attribute,
								item,
							)
						}
					/>
				</div>
				<div
					className="column-spaced"
					style={{ fontSize: 'smaller', marginTop: '4px' }}>
					{item && item !== 'undefined' ? (
						item
					) : (
						<span className="italic">
							[No {titleFilterAttribute.label}]
						</span>
					)}
				</div>
				<div
					className="column-right"
					style={{ fontSize: 'smaller', marginTop: '4px' }}>
					{filteredList && filteredList[item] && (
						<span>
							{filteredList[item].length}&nbsp;&bull;&nbsp;
						</span>
					)}{' '}
					({originalFilteredList[item].length})
				</div>
				<div className="clear" />
			</div>
		));
	};

	getInitialState = (attribute, item) => {
		const activeFilters = this.state.activeFilters;
		return (
			activeFilters.filter(
				af => af.attribute === attribute && af.item === item,
			).length > 0
		);
	};

	filterResults = () => {
		var { titles } = this.props;
		const { activeFilters, activeFilterSections } = this.state;
		titles = titles.filter(function(item) {
			var hits = 0;
			for (let i = 0; i < activeFilterSections.length; i++) {
				var attribute = activeFilterSections[i];
				var relevantActiveFilters =
					activeFilters &&
					activeFilters.filter(af => af.attribute === attribute);
				if (relevantActiveFilters) {
					for (let j = 0; j < relevantActiveFilters.length; j++) {
						if (
							item[attribute] === relevantActiveFilters[j].item ||
							(!item[attribute] &&
								relevantActiveFilters[j].item === 'undefined')
						) {
							hits += 1;
						}
					}
				}
			}
			return hits === activeFilterSections.length;
		});

		this.setState({
			filteredTitleCount: titles.length,
			filteredTitles: titles,
			filterListKey: this.props.listKey,
		});

		this.props.sendData(
			titles
				? titles.map(function(item) {
						return item.sku;
				  })
				: [],
			this.state.filterListKey,
		);
	};

	applyFilters = () => {
		this.props.sendData(
			this.state.filteredTitles.map(function(item) {
				return item.sku;
			}),
		);
	};
}

export default withIsMobile(TitleFilter);
